var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Component } from 'react';
import ToolTipIconUI from '../ToolTipIcon/ToolTipIconUI';
/**
 * TODO: Combine this with CurrencyInputUI somehow. This is basically just copy pasted which means theres some optimizing to do
 */
var TextInputUI = /** @class */ (function (_super) {
    __extends(TextInputUI, _super);
    function TextInputUI(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            textValue: props.textValue,
            displayError: false
        };
        return _this;
    }
    TextInputUI.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.textValue !== this.state.textValue) {
            this.setState({ textValue: nextProps.textValue });
        }
    };
    TextInputUI.prototype.immediateUpdateValue = function (value) {
        if (this.props.onImmediateUpdateValue) {
            this.props.onImmediateUpdateValue(value);
        }
    };
    TextInputUI.prototype.onChange = function (event) {
        this.setState({ displayError: false });
        var value = event.target.value;
        value = value.replace('$', '').replace(/,/g, '');
        this.setState({ textValue: value });
        this.immediateUpdateValue(value); // to update state tree immediately
    };
    TextInputUI.prototype.onBlur = function (event) {
        var isValidValue = true;
        if (this.props.onBlurValidation) {
            isValidValue = this.props.onBlurValidation(this.state.textValue);
        }
        if (isValidValue && this.state.textValue) {
            this.setState({ displayError: false });
        }
        else {
            this.setState({ displayError: true });
        }
        if (this.props.onBlur) {
            this.props.onBlur(event.target.value);
        }
        if (!event.currentTarget.value) {
            var labelNode = event.currentTarget.previousSibling || event.currentTarget;
            labelNode.classList.remove('text-input-touched');
        }
    };
    TextInputUI.prototype.onFocus = function (event) {
        if (this.props.forceCursorToEnd) {
            var length_1 = event.target.value.length;
            var inputTarget_1 = event.target;
            if (length_1 > 0) {
                setTimeout(function () {
                    inputTarget_1.setSelectionRange(length_1, length_1);
                }, 0);
            }
        }
    };
    TextInputUI.prototype.onFocused = function (event) {
        var labelNode = event.currentTarget.previousSibling || event.currentTarget;
        labelNode.classList.add('text-input-touched');
    };
    TextInputUI.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, placeHolder = _a.placeHolder, onAlertClick = _a.onAlertClick, id = _a.id, analyticsId = _a.analyticsId, showAlert = _a.showAlert, isReadOnly = _a.isReadOnly;
        var labelDiv = (
        // tslint:disable-next-line:max-line-length
        React.createElement("div", { className: "text-input__label control-label inline-label input-label " + (this.state.textValue ? 'text-input-touched' : '') }, label));
        var placeholderText = placeHolder;
        if (this.state.displayError) {
            placeholderText = placeHolder ? placeholderText : 'Enter a valid value';
        }
        var alertComponent = (React.createElement("div", { className: "info-icon" },
            React.createElement(ToolTipIconUI, { iconClass: "info-circle", onClick: onAlertClick })));
        var inputClasses = 'form-control';
        inputClasses = showAlert ? inputClasses + " show-alert" : inputClasses;
        inputClasses = isReadOnly ? inputClasses + " text-input--read-only" : inputClasses;
        var value = this.state.textValue;
        var textInputContainerClasses = "text-input " + (this.state.displayError === true ? 'input-validation-fail' : '');
        return (React.createElement("div", { className: textInputContainerClasses },
            React.createElement("div", { className: "input-group" },
                label ? labelDiv : null,
                React.createElement("input", { className: inputClasses, id: id, "data-analytics": analyticsId, type: "text", placeholder: placeHolder, value: value, onFocus: function (event) { _this.onFocused(event); }, onChange: function (event) { _this.onChange(event); }, onBlur: function (event) { _this.onBlur(event); } }),
                showAlert ? alertComponent : null)));
    };
    return TextInputUI;
}(Component));
export default TextInputUI;
